/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Order Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { OrderDeleteInfoResponse } from '../models';
// @ts-ignore
import type { OrderErrorConflict } from '../models';
// @ts-ignore
import type { OrderErrorNotFound } from '../models';
// @ts-ignore
import type { OrderGetInfoResponse } from '../models';
// @ts-ignore
import type { OrderIndividualBatchRequest } from '../models';
// @ts-ignore
import type { OrderIndividualBatchResponse } from '../models';
// @ts-ignore
import type { OrderRequest } from '../models';
// @ts-ignore
import type { OrderResponse } from '../models';
// @ts-ignore
import type { OrderUpdateIndividualOrderRequest } from '../models';
/**
 * OrderServiceIndividualOrdersApi - axios parameter creator
 */
export const OrderServiceIndividualOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create several orders for scheduled processing
         * @param {OrderIndividualBatchRequest} orderIndividualBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBatchIndividualOrder: async (orderIndividualBatchRequest: OrderIndividualBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderIndividualBatchRequest' is not null or undefined
            assertParamExists('createBatchIndividualOrder', 'orderIndividualBatchRequest', orderIndividualBatchRequest)
            const localVarPath = `/order/v1/individualOrdersBatched`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderIndividualBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a order for scheduled processing
         * @param {OrderRequest} orderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualOrder: async (orderRequest: OrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderRequest' is not null or undefined
            assertParamExists('createIndividualOrder', 'orderRequest', orderRequest)
            const localVarPath = `/order/v1/individualOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes an existing order by {orderId}
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndividualOrder: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('deleteIndividualOrder', 'orderId', orderId)
            const localVarPath = `/order/v1/individualOrder/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the existing order {orderId}
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualOrder: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getIndividualOrder', 'orderId', orderId)
            const localVarPath = `/order/v1/individualOrder/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing order by {orderId}
         * @param {string} orderId 
         * @param {OrderUpdateIndividualOrderRequest} orderUpdateIndividualOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIndividualOrder: async (orderId: string, orderUpdateIndividualOrderRequest: OrderUpdateIndividualOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('updateIndividualOrder', 'orderId', orderId)
            // verify required parameter 'orderUpdateIndividualOrderRequest' is not null or undefined
            assertParamExists('updateIndividualOrder', 'orderUpdateIndividualOrderRequest', orderUpdateIndividualOrderRequest)
            const localVarPath = `/order/v1/individualOrder/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderUpdateIndividualOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderServiceIndividualOrdersApi - functional programming interface
 */
export const OrderServiceIndividualOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderServiceIndividualOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create several orders for scheduled processing
         * @param {OrderIndividualBatchRequest} orderIndividualBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBatchIndividualOrder(orderIndividualBatchRequest: OrderIndividualBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderIndividualBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBatchIndividualOrder(orderIndividualBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceIndividualOrdersApi.createBatchIndividualOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a order for scheduled processing
         * @param {OrderRequest} orderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIndividualOrder(orderRequest: OrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIndividualOrder(orderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceIndividualOrdersApi.createIndividualOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes an existing order by {orderId}
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIndividualOrder(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDeleteInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIndividualOrder(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceIndividualOrdersApi.deleteIndividualOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the existing order {orderId}
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndividualOrder(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderGetInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndividualOrder(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceIndividualOrdersApi.getIndividualOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing order by {orderId}
         * @param {string} orderId 
         * @param {OrderUpdateIndividualOrderRequest} orderUpdateIndividualOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIndividualOrder(orderId: string, orderUpdateIndividualOrderRequest: OrderUpdateIndividualOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIndividualOrder(orderId, orderUpdateIndividualOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceIndividualOrdersApi.updateIndividualOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderServiceIndividualOrdersApi - factory interface
 */
export const OrderServiceIndividualOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderServiceIndividualOrdersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create several orders for scheduled processing
         * @param {OrderServiceIndividualOrdersApiCreateBatchIndividualOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBatchIndividualOrder(requestParameters: OrderServiceIndividualOrdersApiCreateBatchIndividualOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderIndividualBatchResponse> {
            return localVarFp.createBatchIndividualOrder(requestParameters.orderIndividualBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a order for scheduled processing
         * @param {OrderServiceIndividualOrdersApiCreateIndividualOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIndividualOrder(requestParameters: OrderServiceIndividualOrdersApiCreateIndividualOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.createIndividualOrder(requestParameters.orderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes an existing order by {orderId}
         * @param {OrderServiceIndividualOrdersApiDeleteIndividualOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIndividualOrder(requestParameters: OrderServiceIndividualOrdersApiDeleteIndividualOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderDeleteInfoResponse> {
            return localVarFp.deleteIndividualOrder(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the existing order {orderId}
         * @param {OrderServiceIndividualOrdersApiGetIndividualOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualOrder(requestParameters: OrderServiceIndividualOrdersApiGetIndividualOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderGetInfoResponse> {
            return localVarFp.getIndividualOrder(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing order by {orderId}
         * @param {OrderServiceIndividualOrdersApiUpdateIndividualOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIndividualOrder(requestParameters: OrderServiceIndividualOrdersApiUpdateIndividualOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.updateIndividualOrder(requestParameters.orderId, requestParameters.orderUpdateIndividualOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createBatchIndividualOrder operation in OrderServiceIndividualOrdersApi.
 */
export interface OrderServiceIndividualOrdersApiCreateBatchIndividualOrderRequest {
    readonly orderIndividualBatchRequest: OrderIndividualBatchRequest
}

/**
 * Request parameters for createIndividualOrder operation in OrderServiceIndividualOrdersApi.
 */
export interface OrderServiceIndividualOrdersApiCreateIndividualOrderRequest {
    readonly orderRequest: OrderRequest
}

/**
 * Request parameters for deleteIndividualOrder operation in OrderServiceIndividualOrdersApi.
 */
export interface OrderServiceIndividualOrdersApiDeleteIndividualOrderRequest {
    readonly orderId: string
}

/**
 * Request parameters for getIndividualOrder operation in OrderServiceIndividualOrdersApi.
 */
export interface OrderServiceIndividualOrdersApiGetIndividualOrderRequest {
    readonly orderId: string
}

/**
 * Request parameters for updateIndividualOrder operation in OrderServiceIndividualOrdersApi.
 */
export interface OrderServiceIndividualOrdersApiUpdateIndividualOrderRequest {
    readonly orderId: string

    readonly orderUpdateIndividualOrderRequest: OrderUpdateIndividualOrderRequest
}

/**
 * OrderServiceIndividualOrdersApi - object-oriented interface
 */
export class OrderServiceIndividualOrdersApi extends BaseAPI {
    /**
     * 
     * @summary Create several orders for scheduled processing
     * @param {OrderServiceIndividualOrdersApiCreateBatchIndividualOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBatchIndividualOrder(requestParameters: OrderServiceIndividualOrdersApiCreateBatchIndividualOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceIndividualOrdersApiFp(this.configuration).createBatchIndividualOrder(requestParameters.orderIndividualBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a order for scheduled processing
     * @param {OrderServiceIndividualOrdersApiCreateIndividualOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createIndividualOrder(requestParameters: OrderServiceIndividualOrdersApiCreateIndividualOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceIndividualOrdersApiFp(this.configuration).createIndividualOrder(requestParameters.orderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes an existing order by {orderId}
     * @param {OrderServiceIndividualOrdersApiDeleteIndividualOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteIndividualOrder(requestParameters: OrderServiceIndividualOrdersApiDeleteIndividualOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceIndividualOrdersApiFp(this.configuration).deleteIndividualOrder(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the existing order {orderId}
     * @param {OrderServiceIndividualOrdersApiGetIndividualOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getIndividualOrder(requestParameters: OrderServiceIndividualOrdersApiGetIndividualOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceIndividualOrdersApiFp(this.configuration).getIndividualOrder(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing order by {orderId}
     * @param {OrderServiceIndividualOrdersApiUpdateIndividualOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateIndividualOrder(requestParameters: OrderServiceIndividualOrdersApiUpdateIndividualOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceIndividualOrdersApiFp(this.configuration).updateIndividualOrder(requestParameters.orderId, requestParameters.orderUpdateIndividualOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

